var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"main"},[_vm._m(0),_c('div',[_vm._v("系统将在"+_vm._s(_vm.second)+"秒后自动跳转到首页，如果没有请 "),_c('span',{staticClass:"toIndex",on:{"click":_vm.toIndex}},[_vm._v("点击手动跳转")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('i',{staticClass:"el-icon-success"}),_c('div',{staticClass:"text"},[_vm._v("恭喜您，信息提交成功！")])])
}]

export { render, staticRenderFns }